// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
import Vant, { Tag, Icon } from "vant";
import { Lazyload } from "vant";
import "vant/lib/index.css";
import "./permission";
import defaultPhoto from "./assets/defaultPhoto.png";
import defaultPhoto0 from "./assets/defaultPhoto0.jpg";
import defaultPhoto1 from "./assets/defaultPhoto1.jpg";
import { getFormatTime, getCompleteTime, getOverdue } from "./utils/tools";
import VueClipboard from "vue-clipboard2";
import FastClick from "fastclick";
// import VConsole from 'vconsole'

Vue.config.productionTip = false;

Vue.prototype.defaultPhoto = defaultPhoto;
Vue.prototype.defaultPhoto0 = defaultPhoto0;
Vue.prototype.defaultPhoto1 = defaultPhoto1;
Vue.prototype.getFormatTime = getFormatTime;
Vue.prototype.getCompleteTime = getCompleteTime;
Vue.prototype.getOverdue = getOverdue;
Vue.prototype.$eventBus = new Vue();

window.addEventListener(
  "orientationchange" in window ? "orientationchange" : "resize",
  (function() {
    // 判断是屏幕旋转还是resize
    function c() {
      var d = document.documentElement; // 获取html元素
      var cw = d.clientWidth || 750;
      d.style.fontSize = 20 * (cw / 375) + "px";
    }
    c();
    return c;
  })(),
  false
);
Vue.use(VueClipboard);
Vue.use(Vant);
Vue.use(Lazyload);
//     const vConsole = new VConsole()
// Vue.use(vConsole)
// console.info("vconsole-info-测试")
// FastClick.attach(document.body);
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js